/**
 * Sanitize Supabase auth error messages.
 *
 * Never expose raw Supabase error strings to the user — they can leak
 * internal implementation details and enable account enumeration attacks.
 */
export function sanitizeAuthError(rawMessage: string): string {
  const lower = rawMessage.toLowerCase();

  if (
    lower.includes("user already registered") ||
    lower.includes("already exists") ||
    lower.includes("email already")
  ) {
    return "Identifiants incorrects ou compte inexistant.";
  }

  if (
    lower.includes("invalid login") ||
    lower.includes("invalid credentials") ||
    lower.includes("wrong password")
  ) {
    return "Email ou mot de passe incorrect.";
  }

  if (lower.includes("email not confirmed")) {
    return "Veuillez confirmer votre adresse e-mail avant de vous connecter.";
  }

  if (lower.includes("password") && lower.includes("short")) {
    return "Le mot de passe est trop court (minimum 6 caractères).";
  }

  if (
    lower.includes("rate limit") ||
    lower.includes("too many") ||
    lower.includes("429")
  ) {
    return "Trop de tentatives. Veuillez réessayer dans quelques minutes.";
  }

  // Generic fallback — never expose raw Supabase message
  return "Une erreur est survenue. Veuillez réessayer.";
}

/**
 * Sanitize user input for safe display in "no results" messages.
 * Strips HTML tags and truncates to a safe length.
 */
export function sanitizeDisplayText(input: string, maxLength = 100): string {
  return input
    .replace(/[<>'"&]/g, "")
    .slice(0, maxLength);
}
